import React from 'react';
import MediaTypeInfo from './MediaTypeInfo/MediaTypeInfo';
import PropTypes from 'prop-types';
import style from '../../../../styles/styles';
import styles from './MediaTypeFull.css';
import {Avatar} from "material-ui";
import Dropzone from 'react-dropzone';

class MediaTypeFull extends React.Component {

    static propTypes = {
        app: PropTypes.object.isRequired,
        mediaType: PropTypes.object.isRequired,
        postPicture: PropTypes.func.isRequired
    };

    static supportedDropFiles = 'image/jpeg, image/png';

    handlePictureDrop = (accepted, rejected) => {
        this.setState({uploadingFiles: []});

        accepted.forEach((picture) => {
            console.log('Uploading file ' + picture.name);
            this.props.postPicture(this.props.app.id, this.props.mediaType.id, picture, (progressEvent) => {
                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                const uploadingState = this.state.uploadingFiles.filter((mediaPercent) => mediaPercent.media !== picture);
                console.log(picture.name + ' -> ' + percentCompleted + '% (' + progressEvent.loaded + ' / ' + progressEvent.total + ')');
                this.setState({
                    uploadingFiles: [
                        ...uploadingState,
                        {
                            picture: picture,
                            percent: percentCompleted
                        }
                    ]
                });
            });
        });
    };

    render() {
        const {mediaType} = this.props;

        return (
            <div>
                <Dropzone
                    ref={(node) => {
                        this.dropzoneRef = node
                    }}
                    accept={MediaTypeFull.supportedDropFiles}
                    onDrop={this.handlePictureDrop}
                    multiple={false}
                    style={{ }}
                >
                    <Avatar
                        icon={mediaType.picture && <img src={mediaType.picture} alt="" style={style.image.contain}/>}
                        size={75}
                        backgroundColor={mediaType.color}
                        style={{ ...styles.avatar, overflow: 'hidden' }}
                    />
                </Dropzone>
                <div className="row">
                    <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                        <MediaTypeInfo mediaType={mediaType}/>
                    </div>
                </div>
            </div>
        );
    }
}

export default MediaTypeFull;



// WEBPACK FOOTER //
// src/components/media/MediaType/MediaTypeFull/MediaTypeFull.js